import { BASE_IMAGE_COMBINED_URL } from '../constants';
import {
  BankingIcon,
  BusinessIcon,
  CreditCardIcon,
  FinancialAdvisorIcon,
  InsuranceIcon,
  MortgageIcon,
  OnlineBrokerIcon,
  PersonalLoansIcon,
  StudentLoansIcon,
} from './icons';
import { ActionsEnum, VerticalOption, VerticalsEnum } from './types';

export const VERTICAL_OPTIONS: VerticalOption[] = [
  {
    value: VerticalsEnum.CreditCards,
    label: 'credit card',
    icon: <CreditCardIcon />,
    hasTwoDropdowns: true,
  },
  {
    value: VerticalsEnum.Insurance,
    label: 'insurance company',
    icon: <InsuranceIcon />,
    hasTwoDropdowns: true,
  },
  {
    value: VerticalsEnum.PersonalLoans,
    label: 'personal loan',
    icon: <PersonalLoansIcon />,
    hasTwoDropdowns: true,
  },
  {
    value: VerticalsEnum.Mortgages,
    label: 'mortgage',
    icon: <MortgageIcon />,
    hasTwoDropdowns: true,
  },
  {
    value: VerticalsEnum.BusinessLoans,
    label: 'small business loan',
    icon: <BusinessIcon />,
    hasTwoDropdowns: true,
  },
  {
    value: VerticalsEnum.FinancialAdvisors,
    label: 'financial advisor',
    icon: <FinancialAdvisorIcon />,
    hasTwoDropdowns: false,
  },
  {
    value: VerticalsEnum.Banking,
    label: 'savings account',
    icon: <BankingIcon />,
    hasTwoDropdowns: false,
  },
  {
    value: VerticalsEnum.OnlineBroker,
    label: 'online broker',
    icon: <OnlineBrokerIcon />,
    hasTwoDropdowns: false,
  },
  {
    value: VerticalsEnum.StudentLoans,
    label: 'student loan',
    icon: <StudentLoansIcon />,
    hasTwoDropdowns: false,
  },
];

export const ACTION_OPTIONS = [
  { value: ActionsEnum.Personalize, label: 'see personalized options' },
  { value: ActionsEnum.Compare, label: 'compare my options' },
];

export const ANALYTICS_SCHEMA = {
  [VerticalsEnum.CreditCards]: {
    [ActionsEnum.Personalize]: 'hp_shopping_quiz_personalize_cc_click',
    [ActionsEnum.Compare]: 'hp_shopping_quiz_compare_cc_click',
  },
  [VerticalsEnum.Insurance]: {
    [ActionsEnum.Personalize]: 'hp_shopping_quiz_personalize_in_click',
    [ActionsEnum.Compare]: 'hp_shopping_quiz_compare_in_click',
  },
  [VerticalsEnum.PersonalLoans]: {
    [ActionsEnum.Personalize]: 'hp_shopping_quiz_personalize_pl_click',
    [ActionsEnum.Compare]: 'hp_shopping_quiz_compare_pl_click',
  },
  [VerticalsEnum.Mortgages]: {
    [ActionsEnum.Personalize]: 'hp_shopping_quiz_personalize_mrt_click',
    [ActionsEnum.Compare]: 'hp_shopping_quiz_compare_mrt_click',
  },
  [VerticalsEnum.BusinessLoans]: {
    [ActionsEnum.Personalize]: 'hp_shopping_quiz_personalize_smb_click',
    [ActionsEnum.Compare]: 'hp_shopping_quiz_compare_smb_click',
  },
  [VerticalsEnum.FinancialAdvisors]: {
    [ActionsEnum.Personalize]: 'hp_shopping_quiz_default_advisor_click',
    [ActionsEnum.Compare]: 'hp_shopping_quiz_default_advisor_click',
  },
  [VerticalsEnum.Banking]: {
    [ActionsEnum.Personalize]: 'hp_shopping_quiz_default_bnk_click',
    [ActionsEnum.Compare]: 'hp_shopping_quiz_default_bnk_click',
  },
  [VerticalsEnum.OnlineBroker]: {
    [ActionsEnum.Personalize]: 'hp_shopping_quiz_default_broker_click',
    [ActionsEnum.Compare]: 'hp_shopping_quiz_default_broker_click',
  },
  [VerticalsEnum.StudentLoans]: {
    [ActionsEnum.Personalize]: 'hp_shopping_quiz_default_sl_click',
    [ActionsEnum.Compare]: 'hp_shopping_quiz_default_sl_click',
  },
};

export const COMBINED_SHOPPING_MODULE_CONTENT = {
  [VerticalsEnum.CreditCards]: {
    images: {
      desktopURL: `${BASE_IMAGE_COMBINED_URL}/desktop-credit-cards.png`,
      mobileURL: `${BASE_IMAGE_COMBINED_URL}/Verticals_mobile%3Dcredit+card.png`,
      alt: 'Credit Card Hero Image',
    },
  },
  [VerticalsEnum.Insurance]: {
    images: {
      desktopURL: `${BASE_IMAGE_COMBINED_URL}/desktop-insurance.png`,
      mobileURL: `${BASE_IMAGE_COMBINED_URL}/Verticals_mobile%3Dinsurance.png`,
      alt: 'Insurance Hero Image',
    },
  },
  [VerticalsEnum.Mortgages]: {
    images: {
      desktopURL: `${BASE_IMAGE_COMBINED_URL}/desktop-mortgage.png`,
      mobileURL: `${BASE_IMAGE_COMBINED_URL}/Verticals_mobile%3Dmortgages.png`,
      alt: 'Mortgages Hero Image',
    },
  },
  [VerticalsEnum.PersonalLoans]: {
    images: {
      desktopURL: `${BASE_IMAGE_COMBINED_URL}/desktop-personal-loans.png`,
      mobileURL: `${BASE_IMAGE_COMBINED_URL}/Verticals_mobile%3Dpersonal+loans.png`,
      alt: 'Personal Loans Hero Image',
    },
  },
  [VerticalsEnum.BusinessLoans]: {
    images: {
      desktopURL: `${BASE_IMAGE_COMBINED_URL}/desktop-smb.png`,
      mobileURL: `${BASE_IMAGE_COMBINED_URL}/Verticals_mobile%3Dsmall+businesses.png`,
      alt: 'Small Business Hero Image',
    },
  },
  [VerticalsEnum.Banking]: {
    images: {
      desktopURL: `${BASE_IMAGE_COMBINED_URL}/desktop-banking.png`,
      mobileURL: `${BASE_IMAGE_COMBINED_URL}/Verticals_mobile%3Dbanking.png`,
      alt: 'Banking Hero Image',
    },
  },
  [VerticalsEnum.OnlineBroker]: {
    images: {
      desktopURL: `${BASE_IMAGE_COMBINED_URL}/desktop-online-broker.png`,
      mobileURL: `${BASE_IMAGE_COMBINED_URL}/Verticals_mobile%3Dinvesting.png`,
      alt: 'Online Broker Hero Image',
    },
  },
  [VerticalsEnum.StudentLoans]: {
    images: {
      desktopURL: `${BASE_IMAGE_COMBINED_URL}/desktop-student-loans.png`,
      mobileURL: `${BASE_IMAGE_COMBINED_URL}/Verticals_mobile%3Dstudent+loans.png`,
      alt: 'Student Loans Hero Image',
    },
  },
  [VerticalsEnum.FinancialAdvisors]: {
    images: {
      desktopURL: `${BASE_IMAGE_COMBINED_URL}/desktop-financial-advisor.png`,
      mobileURL: `${BASE_IMAGE_COMBINED_URL}/Verticals_mobile%3Dfinancial+advisor.png`,
      alt: 'Financial Advisor Hero Image',
    },
  },
};

export const COMBINED_SHOPPING_MODULE_CTA_LINKS = {
  [VerticalsEnum.CreditCards]: {
    [ActionsEnum.Personalize]:
      'https://www.nerdwallet.com/recommend/CreditScore?trk_location=cc_super_bowl',
    [ActionsEnum.Compare]: 'https://www.nerdwallet.com/the-best-credit-cards',
  },
  [VerticalsEnum.PersonalLoans]: {
    [ActionsEnum.Personalize]:
      'https://www.nerdwallet.com/prequalify/personal-loan/apply?affiliateName=NerdWallet&affiliateId=1333&subId1=organic&subId2=pl_superbowl&subId3=homepage',
    [ActionsEnum.Compare]: 'https://www.nerdwallet.com/personal-loans',
  },
  [VerticalsEnum.BusinessLoans]: {
    [ActionsEnum.Personalize]:
      'https://www.nerdwallet.com/redirect/d56b267e-073b-11ea-a8c5-179bb79b48c9',
    [ActionsEnum.Compare]: 'https://www.nerdwallet.com/small-business-loans',
  },
  [VerticalsEnum.FinancialAdvisors]: {
    [ActionsEnum.Personalize]:
      'https://www.nerdwallet.com/best/investing/financial-advisors',
    [ActionsEnum.Compare]:
      'https://www.nerdwallet.com/best/investing/financial-advisors',
  },
  [VerticalsEnum.Banking]: {
    [ActionsEnum.Personalize]:
      'https://www.nerdwallet.com/best/banking/high-yield-online-savings-accounts',
    [ActionsEnum.Compare]:
      'https://www.nerdwallet.com/best/banking/high-yield-online-savings-accounts',
  },
  [VerticalsEnum.OnlineBroker]: {
    [ActionsEnum.Personalize]:
      'https://www.nerdwallet.com/best/investing/online-brokers-for-stock-trading',
    [ActionsEnum.Compare]:
      'https://www.nerdwallet.com/best/investing/online-brokers-for-stock-trading',
  },
  [VerticalsEnum.StudentLoans]: {
    [ActionsEnum.Personalize]:
      'https://www.nerdwallet.com/best/loans/student-loans/private-student-loans',
    [ActionsEnum.Compare]:
      'https://www.nerdwallet.com/best/loans/student-loans/private-student-loans',
  },
};

export const ARROW_URL = `${BASE_IMAGE_COMBINED_URL}/desktop-arrow.png`;
